import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
import { useScrollAnimation } from '@src/hooks/useScrollAnimation';
import { motion, Variants } from 'framer-motion';
import { createContext, useContext } from 'react';
interface AnimationContextType {
  isVisible: boolean;
}
const AnimationContext = createContext<AnimationContextType>({
  isVisible: false
});
export const useAnimationContext = () => {
  return useContext(AnimationContext);
};
interface AnimatedSectionProps extends BoxProps {
  children: React.ReactNode;
  variants?: Variants;
  threshold?: number;
  rootMargin?: string;
  triggerOnce?: boolean;
  initial?: string;
  animate?: string;
  exit?: string;
  style?: BoxProps['style'];
}
export const AnimatedSection = t0 => {
  const $ = _c(33);
  let boxProps;
  let children;
  let rootMargin;
  let style;
  let t1;
  let t2;
  let t3;
  let t4;
  let threshold;
  let variants;
  if ($[0] !== t0) {
    ({
      children,
      variants,
      threshold,
      rootMargin,
      triggerOnce: t1,
      initial: t2,
      animate: t3,
      exit: t4,
      style,
      ...boxProps
    } = t0);
    $[0] = t0;
    $[1] = boxProps;
    $[2] = children;
    $[3] = rootMargin;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = threshold;
    $[10] = variants;
  } else {
    boxProps = $[1];
    children = $[2];
    rootMargin = $[3];
    style = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    threshold = $[9];
    variants = $[10];
  }
  const triggerOnce = t1 === undefined ? true : t1;
  const initial = t2 === undefined ? "hidden" : t2;
  const animate = t3 === undefined ? "visible" : t3;
  const exit = t4 === undefined ? "hidden" : t4;
  let t5;
  if ($[11] !== rootMargin || $[12] !== threshold || $[13] !== triggerOnce) {
    t5 = {
      threshold,
      rootMargin,
      triggerOnce
    };
    $[11] = rootMargin;
    $[12] = threshold;
    $[13] = triggerOnce;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const {
    isVisible,
    elementRef
  } = useScrollAnimation(t5);
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 20
    };
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      hidden: t6,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
          ease: [0.34, 1.56, 0.64, 1]
        }
      }
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const defaultVariants = t7;
  let t8;
  if ($[17] !== isVisible) {
    t8 = {
      isVisible
    };
    $[17] = isVisible;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = isVisible ? animate : initial;
  const t10 = variants || defaultVariants;
  let t11;
  if ($[19] !== children || $[20] !== exit || $[21] !== initial || $[22] !== style || $[23] !== t10 || $[24] !== t9) {
    t11 = <motion.div animate={t9} exit={exit} initial={initial} style={style} variants={t10}>{children}</motion.div>;
    $[19] = children;
    $[20] = exit;
    $[21] = initial;
    $[22] = style;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t8) {
    t12 = <AnimationContext.Provider value={t8}>{t11}</AnimationContext.Provider>;
    $[26] = t11;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== boxProps || $[30] !== elementRef || $[31] !== t12) {
    t13 = <Box ref={elementRef} {...boxProps}>{t12}</Box>;
    $[29] = boxProps;
    $[30] = elementRef;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};